<template>
  <div
    class="modal modal-widget modal-cart fade"
    id="cartModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="cartModalLabel"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="cartModalLabel">{{$t('cart')}}</h4>
            <a
              href="#"
              class="icon icon-cross"
              data-dismiss="modal"
              aria-label="Close"
              >{{$t('close')}}</a
            >
          </div>

          <div v-if="cart.items.length" class="modal-body">
            <div class="modal-cart-list">
              <div
                v-for="(item, index) in cart.items"
                :key="index"
                class="modal-cart-list__line"
              >
                <div>{{ item.name || '' }}</div>
                <div class="icon-price">
                  {{ item.qty }}
                  <div class="icon icon_xs icon-cross mx-1"></div>
                  {{ item.price }}€
                </div>
              </div>
              <div class="modal-cart-list__line modal-cart-list__line_total">
                <div>{{$t('totalHt')}}</div>
                <div class="icon-price">{{ totalHT }} €</div>
              </div>
            </div>
          </div>
          <div v-else class="modal-body modal-body_empty">
            <div class="text-muted text-small">{{$t('emptyCart')}}</div>
          </div>
          <div class="modal-footer" v-if="cart.items.length">
            <a href="/cart" class="w-100 btn btn-primary">{{$t('goToCart')}}</a>
            <a href="#" class="text-danger" @click.prevent.stop="clearCart"
              >{{$t('clearCart')}}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
export default {
  name: 'CartModal',
  computed: {
    ...mapFields(['cart']),
    ...mapGetters(['totalHT']),
  },
  methods: {
    clearCart() {
      this.$store.commit('CLEAR_CART')
      this.$store.commit('SET_STEP', 0)
      this.closeModal()
    },
    closeModal() {
      setTimeout(() => {
        $('#cartModal').modal('hide')
      }, 500)
    },
  },
}
</script>

<style scoped></style>
